import PdImage from '../../../components/pd-image/pd-image'
import PdMetaContactUsButton from '../../../components/pd-meta-contactus-button/pd-meta-contactus-button'
import { useD9 } from '../../../hooks/use-d9-data'

export function Section5() {
  const { section5 } = useD9()

  return (
    <section className="w-full bg-[#141414] laptop:py-30 py-15">
      <div className="w-300 max-w-full mx-auto px-6 laptop:px-0 flex laptop:flex-row laptop:justify-between flex-col gap-y-38px">
        {/* body image */}
        <div className="laptop:w-370px w-186px laptop:h-120 h-60 mx-auto">
          <PdImage src={section5.d9Image} width="100%" height="100%" object="contain" />
        </div>

        <div className="flex flex-col w-784px max-w-full laptop:gap-12 gap-6">
          {/* header */}
          <div className="pb-3 laptop:pb-6 border-b border-[#bbc3ce]">
            <h2 className="text-white/90 text-2xl laptop:text-40 font-semibold">{section5.title}</h2>
          </div>

          {/* spec table */}
          <dl className="grid laptop:grid-cols-2 laptop:gap-12 gap-6">
            {section5.spec.map((item) => {
              const label = item[0]
              // item[1] is string or string[]
              const values = typeof item[1] === 'string' ? [item[1]] : item[1]

              return (
                <div key={item[0]}>
                  <dt className="text-white/60 text-sm laptop:text-base font-normal">{item[0]}</dt>
                  <dd className="flex flex-col text-white/90 text-xs laptop:text-base font-medium mt-2">
                    {values.map((v) => (
                      <span key={v}>{v}</span>
                    ))}
                  </dd>
                </div>
              )
            })}
          </dl>

          {/* Statement */}
          <details className="text-white/60 laptop:text-base text-sm font-normal" open>
            <summary className="pb-2" style={{ listStyle: 'none' }}>
              {section5.statementTitle}
            </summary>
            {section5.statement.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </details>
          {/* Contact us button */}
          <PdMetaContactUsButton className="laptop:h-10 laptop:text-base" robotCode="pudud9" />
        </div>
      </div>
    </section>
  )
}
